import {
  FadvBaseDatePicker
} from "./chunk.374AFDAL.js";
import {
  createDatePickerMaskOptions
} from "./chunk.EY5SW4NC.js";
import {
  formatForDateInput,
  getDateFromDateInput
} from "./chunk.HLRT5FOM.js";
import {
  IMask
} from "./chunk.7I2462UJ.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  dateAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/date-picker/date-picker.ts
var FadvDatePicker = class extends FadvBaseDatePicker {
  async firstUpdated() {
    await this.updateComplete;
    this.handlePatternChange();
  }
  handlePatternChange() {
    var _a;
    (_a = this.mask) == null ? void 0 : _a.destroy();
    this.mask = void 0;
    if (this.datePattern) {
      this.mask = IMask(this.input, createDatePickerMaskOptions(this.datePattern, this.min, this.max));
    }
  }
  handleChange(e2) {
    if (this.mask) {
      this.value = this.mask.typedValue;
    } else {
      this.value = getDateFromDateInput(this.input);
    }
    if (this.value && !this.isInRange(this.value)) {
      this.input.value = "";
      this.value = void 0;
      return;
    }
    emit(this, "fadv-calendar-date-change", { detail: { date: this.value } });
    e2.preventDefault();
    e2.stopPropagation();
  }
  handleCalendarDateChange(e2) {
    if (!e2.detail.date)
      return;
    this.value = e2.detail.date;
    if (this.mask && this.datePattern) {
      this.mask.value = this.getPatternFormattedDate(this.value);
      this.mask.updateValue();
    } else {
      this.input.value = formatForDateInput(this.value) || "";
    }
    this.open = false;
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  clear() {
    this.input.value = "";
    this.value = void 0;
  }
  renderCalendar() {
    return $`<fadv-calendar hidden role="menu" aria-hidden=${!this.open} aria-label=${this.label} date=${this.value} date-pattern=${this.datePattern} min-date=${l(this.min)} max-date=${l(this.max)} @fadv-calendar-date-change=${this.handleCalendarDateChange} ></fadv-calendar>`;
  }
  renderInput() {
    return $`<input required size="1" part="input" id=${this.inputId} class="form-control__control" type=${this.datePattern ? "text" : "date"} name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} min=${l(formatForDateInput(this.min))} max=${l(formatForDateInput(this.max))} ?autofocus=${this.autofocus} .value=${l2(this.getDateInputValue(this.value))} placeholder=${this.datePattern && !this.placeholder ? this.datePattern.toLowerCase() : this.placeholder} aria-labelledby=${l(this.getLabelledBy())} aria-invalid=${this.invalid ? "true" : "false"} @change=${this.handleChange} @focus=${this.handleInputFocus} @blur=${this.handleBlur} @click=${this.handleInputClick} @keydown=${this.handleInputKeydown} />`;
  }
};
__decorateClass([
  i("input")
], FadvDatePicker.prototype, "input", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter })
], FadvDatePicker.prototype, "value", 2);
__decorateClass([
  watch("datePattern", { waitUntilFirstUpdate: true })
], FadvDatePicker.prototype, "handlePatternChange", 1);
FadvDatePicker = __decorateClass([
  n("fadv-date-picker")
], FadvDatePicker);

export {
  FadvDatePicker
};
